import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { LeaveTypeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import i18n from 'modules/core/lib/i18n'

import ArchivedLeaveTypes from './ArchivedLeaveTypes'
import Item from './Item'

interface LeaveTypesProps {
  data: LeaveTypeFragment[]
}

const LeaveTypes: React.FC<LeaveTypesProps> = ({ data }) => {
  const leaveTypes = data
  const visibleLeaveTypes = leaveTypes.filter((leaveType) => leaveType.active)
  const archivedLeaveTypes = leaveTypes.filter((leaveType) => !leaveType.active)

  return (
    <>
      <Box
        paddingY="s24"
        flexDirection="row"
        gap="s8"
        extra={{ 'data-intercom-target': 'leave-types-list' }}
      >
        <Text.Normal weight="medium">
          {i18n.t('settings.leave_types.list.unarchived_list')}
        </Text.Normal>
      </Box>
      <BoxList>
        {visibleLeaveTypes.map((type) => (
          <Item key={type.id} leaveType={type} />
        ))}
      </BoxList>
      {archivedLeaveTypes.length >= 1 && <ArchivedLeaveTypes types={archivedLeaveTypes} />}
    </>
  )
}

export default observer(LeaveTypes)
